import React from "react";
import { Form, InputGroup, Button, Dropdown, Badge } from "react-bootstrap";
import { IoSearch, IoFilter, IoClose } from "react-icons/io5";

const SearchAndFilter = ({
  searchTerm = "",
  selectedStatus = "ALL",
  selectedType = "ALL",
  selectedTypeKonten = "ALL",
  onSearchChange = () => {},
  onSearchSubmit = () => {},
  onStatusChange = () => {},
  onTypeChange = () => {},
  onTypeKontenChange = () => {},
  onClearFilters = () => {},
}) => {
  // Status options
  const statusOptions = [
    { value: "ALL", label: "All Status" },
    { value: "DRAFT", label: "Draft" },
    { value: "PUBLISHED", label: "Published" },
    { value: "ARCHIVED", label: "Archived" },
  ];

  // Type options
  const typeOptions = [
    { value: "ALL", label: "All Types" },
    { value: "TEKNOLOGI", label: "Teknologi" },
    { value: "PENDIDIKAN", label: "Pendidikan" },
    { value: "KESEHATAN", label: "Kesehatan" },
    { value: "BISNIS", label: "Bisnis" },
    { value: "OLAHRAGA", label: "Olahraga" },
  ];

  const typeKontenOptions = [
    { value: "ALL", label: "All Types Post" },
    { value: "PODCAST", label: "Podcast" },
    { value: "MAJALAH", label: "Majalah" },
    { value: "ARTIKEL", label: "Artikel" },
    { value: "COE", label: "COE" },
    { value: "FASILITAS_LAYANAN", label: "Fasilitas Layanan" },
  ];

  // Check if any filter is active
  const isFilterActive =
    selectedStatus !== "ALL" ||
    selectedType !== "ALL" ||
    selectedTypeKonten !== "ALL";

  return (
    <div className="row g-3 mb-4">
      {/* Search Input */}
      <div className="col-md-4">
        <Form onSubmit={onSearchSubmit}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search artikel by title, content, or type..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            <Button variant="primary" type="submit">
              <IoSearch /> Search
            </Button>
          </InputGroup>
        </Form>
      </div>

      {/* Status Filter */}
      <div className="col-md-1">
        <Dropdown>
          <Dropdown.Toggle
            variant={selectedStatus !== "ALL" ? "primary" : "outline-secondary"}
            className="w-100 d-flex justify-content-between align-items-center"
          >
            <IoFilter />{" "}
            {statusOptions.find((opt) => opt.value === selectedStatus)?.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {statusOptions.map((option) => (
              <Dropdown.Item
                key={option.value}
                active={selectedStatus === option.value}
                onClick={() => onStatusChange(option.value)}
              >
                {option.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Type Post Filter */}
      <div className="col-md-1">
        <Dropdown>
          <Dropdown.Toggle
            variant={
              selectedTypeKonten !== "ALL" ? "primary" : "outline-secondary"
            }
            className="w-100 d-flex justify-content-between align-items-center"
          >
            <IoFilter />{" "}
            {
              typeKontenOptions.find((opt) => opt.value === selectedTypeKonten)
                ?.label
            }
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {typeKontenOptions.map((option) => (
              <Dropdown.Item
                key={option.value}
                active={selectedTypeKonten === option.value}
                onClick={() => onTypeKontenChange(option.value)}
              >
                {option.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="col-md-1">
        <Dropdown>
          <Dropdown.Toggle
            variant={selectedType !== "ALL" ? "primary" : "outline-secondary"}
            className="w-100 d-flex justify-content-between align-items-center"
          >
            <IoFilter />{" "}
            {typeOptions.find((opt) => opt.value === selectedType)?.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {typeOptions.map((option) => (
              <Dropdown.Item
                key={option.value}
                active={selectedType === option.value}
                onClick={() => onTypeChange(option.value)}
              >
                {option.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Active Filters Badge */}
      {isFilterActive && (
        <div className="col-12">
          <div className="d-flex align-items-center gap-2">
            <small className="text-muted">Active filters:</small>
            {selectedStatus !== "ALL" && (
              <Badge bg="primary" className="d-flex align-items-center gap-1">
                Status:{" "}
                {
                  statusOptions.find((opt) => opt.value === selectedStatus)
                    ?.label
                }
                <IoClose
                  size={12}
                  style={{ cursor: "pointer" }}
                  onClick={() => onStatusChange("ALL")}
                />
              </Badge>
            )}
            {selectedType !== "ALL" && (
              <Badge bg="primary" className="d-flex align-items-center gap-1">
                Type:{" "}
                {typeOptions.find((opt) => opt.value === selectedType)?.label}
                <IoClose
                  size={12}
                  style={{ cursor: "pointer" }}
                  onClick={() => onTypeChange("ALL")}
                />
              </Badge>
            )}
            {selectedTypeKonten !== "ALL" && (
              <Badge bg="primary" className="d-flex align-items-center gap-1">
                Type Konten:{" "}
                {typeKontenOptions.find((opt) => opt.value === selectedTypeKonten)?.label}
                <IoClose
                  size={12}
                  style={{ cursor: "pointer" }}
                  onClick={() => onTypeKontenChange("ALL")}
                />
              </Badge>
            )}
            {(selectedStatus !== "ALL" ||
              selectedType !== "ALL" ||
              selectedTypeKonten !== "ALL") && (
              <Button
                variant="link"
                size="sm"
                className="p-0 text-decoration-none"
                onClick={onClearFilters}
              >
                Clear all
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchAndFilter;
